import React from "react";
import {cs} from "@common/react/chain-services";
import {DropdownSelect2} from "@common/ui-components/dropdown-select/dropdown-select2";
import {TextManipulationResultActionSelect} from "../../common/text-manipulation-result-action-select";
import {rColumnValueSelectFromStepOutput} from "../../../../../common/column-value-select-from-step-output/column-value-select-from-step-output";
import {ffToDropdown} from "../../../../../../../../../../common/form/ff-to-dropdown";
import {keepOnly} from "@common/utils/objects";

export const ChangeCaseConfiguration = ({textManipulation, inputStep, model, form}) =>
    cs(() => {
        return (
            <>
                <div className="config-group">
                    <div className="label">Input Column</div>
                    {(() => {
                        const dropdownProps = ffToDropdown(form.field(["textManipulation", "inputValue"]));
                        return rColumnValueSelectFromStepOutput({
                            label: "Column",
                            columns: inputStep.outputColumns,
                            model,
                            disableStaticValue: true,
                            filterColumnFn: (c) => ["Text", "IDUUID"].includes(c.dataType),
                            isValueNotAllowed: (c) => !["Text", "IDUUID"].includes(c.dataType),
                        })({
                            state: {
                                value: dropdownProps.value,
                                onChange: dropdownProps.onChange,
                            },
                            ...keepOnly(dropdownProps, ["domRef", "hasError", "errorMessage"]),
                        });
                    })()}
                </div>

                <div className="config-group">
                    <div className="label">Case Type</div>
                    {DropdownSelect2({
                        label: "Type",
                        list: [
                            {value: "LowerCase", label: "lower case"},
                            {value: "UpperCase", label: "UPPER CASE"},
                            {
                                value: "CapitalizedCase",
                                label: "Capitalize Case (Title Case)",
                            },
                        ],
                        valueToLabel: (v) => v.label,
                        ...ffToDropdown(form.field(["textManipulation", "changeCaseTo"]), ["value"]),
                    })}
                </div>

                {TextManipulationResultActionSelect({
                    state: textManipulation,
                    form,
                })}
            </>
        );
    });
